import { render } from "./importantPrompt.vue?vue&type=template&id=7849b87d&scoped=true"
import script from "./importantPrompt.vue?vue&type=script&lang=js"
export * from "./importantPrompt.vue?vue&type=script&lang=js"

import "./importantPrompt.vue?vue&type=style&index=0&id=7849b87d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7849b87d"]])

export default __exports__